/**
 * Parse text containing <storeproduct .../> tags into an array of segments.
 * Incomplete tags (streaming) are stripped from visible text.
 *
 * Returns: Array of { type: 'text' | 'storeproduct', value: string | attrs }
 */
export function parseBubbleContent(text) {
  const segments = []
  // Match complete self-closing tags only
  const tagRe = /<storeproduct\s([^>]*?)\/>/g
  let last = 0
  let match

  // Strip any incomplete tag at the end (streaming artifact)
  const safeText = text.replace(/<storeproduct(?:[^>]*)$/, '')

  while ((match = tagRe.exec(safeText)) !== null) {
    if (match.index > last) {
      segments.push({ type: 'text', value: safeText.slice(last, match.index) })
    }
    segments.push({ type: 'storeproduct', value: parseAttrs(match[1]) })
    last = match.index + match[0].length
  }

  if (last < safeText.length) {
    segments.push({ type: 'text', value: safeText.slice(last) })
  }

  return segments
}

function parseAttrs(str) {
  const attrs = {}
  const re = /(\w+)="([^"]*)"/g
  let m
  while ((m = re.exec(str)) !== null) {
    attrs[m[1]] = m[2]
  }
  return attrs
}
